export default __webpack_public_path__ + "static/media/ar_logo_primary.fd9a6478.svg";